import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class GoogleDriveAPI extends BaseAPI {}

export default new GoogleDriveAPI('v1/google-drive', 'GoogleDrive', getApiUrl(apis.GoogleDriveAPI))
